module.exports = __webpack_public_path__ + "img/product-16.c8e16910.jpg";